import View from '../../../Core/View.js';

export default class HeaderVideo extends View {

	initialize() {

		window.onYouTubePlayerAPIReady = this.initPlayer.bind(this);

		this.videoId = this.convertYoutubeURLToId(this.el.dataset.url);

		const player = this.$el.find('.header__video__player').get(0);
		player.id = this.getPlayerId();

		this.loadYoutubeApi();
	}

	destroy() {
	}

	loadYoutubeApi() {
		if (typeof YT !== 'undefined') {
			window.onYouTubePlayerAPIReady();
			return;
		}

		var script = document.createElement('script');
		script.setAttribute('src', 'https://www.youtube.com/iframe_api');
		document.body.appendChild(script);
	}

	initPlayer() {
		this.player = new YT.Player(this.getPlayerId(), {
			width: '100%',
			height: '100%',
			videoId: this.videoId,
			muted: true,
			playerVars: {
				autoplay: 1,
				controls: 0,
				rel: 0,
				showinfo: 0
			},
		});
		this.player.addEventListener('onStateChange', this.handleStateChange.bind(this));
		this.player.addEventListener('onReady', this.handlePlayerReady.bind(this));
	}

	getPlayerId() {
		return 'player-' + this.videoId;
	}

	convertYoutubeURLToId(url) {
		const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
		const match = url.match(regExp);

		return (match && match[7].length == 11) ? match[7] : false;
	}

	handleStateChange(event) {
		switch (event.data) {
			case YT.PlayerState.PLAYING:
				this.player.mute();
				this.el.classList.add('header__video--playing');
				break;

			case YT.PlayerState.PAUSED:
				this.player.playVideo();
				break;

			case YT.PlayerState.ENDED:
				this.player.playVideo();
				break;
		}
	}

	handlePlayerReady() {
		this.player.mute();
	}
}


// WEBPACK FOOTER //
// ./js/Views/Templates/HeaderVideo/HeaderVideo.js